import React, { useEffect, useRef, useState } from 'react';
import { AssignmentModel, AssignmentStatus, TreatmentType } from '../models/superbit-api-models';
import { Select, TimePicker  } from 'antd';
import { Editor } from '@tinymce/tinymce-react';
import { Editor as TinyMCEEditor } from 'tinymce';
import DatePicker from "react-datepicker";
import dayjs from 'dayjs';
// import { CustomerCardModel } from '../models/CustomerCardModel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import './_SigningConfigPopUp.css';
import { SigningModel } from '../models/SigningModel';

type Props = {
    ClosePopup?: Function;
    OnApprove?: Function;
    config?: any;
    messageTitle?: string;
};

const SigningConfigPopup = (props: Props) => {
    const signingModel = new SigningModel();
    const [statuses, setStatuses] = useState<any[]>([]);
    const [tab, setTab] = useState<string>('Statuses');
    const [newStatusName, setNewStatusName] = useState<string>('');

    const loadData = async() => {
        const statusesData = await signingModel.getStatuses();
        const sData = prepareData(statusesData);
        setStatuses(sData);
    }

    const prepareData = (statuses: any[]) => {
        let systemStatuses = statuses.filter((s: any) => s.isLock).sort((a: any, b: any) => (a.name > b.name) ? 1 : -1);
        let notSystemStatuses = statuses.filter((s: any) => !s.isLock).sort((a: any, b: any) => (a.name > b.name) ? 1 : -1);

        console.log('systemStatuses', systemStatuses, 'notSystemStatuses', notSystemStatuses);
        return [
            ...notSystemStatuses,
            ...systemStatuses
        ]
    }

    const closePopup = (status?: string)=>{
        if (props.ClosePopup) {
            props.ClosePopup(status);  
         }
    }
    
    const selectTab = (tabName: string) => {
        setTab(tabName);
    }

    const onNewStatusNameChange = (e: any) => {
        const newName = e.target.value;
        setNewStatusName(newName);
    }

    const onAddStatus = async() => {
        if (newStatusName !== '') {
            const response = await signingModel.addStatus({
                Name: newStatusName
            });
            loadData();
            setNewStatusName('');
        }
    }

    const onDeleteStatus = async(id: string) => {
        if (id !== '') {
            await signingModel.deleteStatus(id);
            loadData();
        }
    }

    const emptyFunc = () => {}

    useEffect(()=>{
        loadData();
    },[])
    
      return ( <>
        <div className={`popup-wrapper signings-config-popup small-config`}>
            <section className="popup-window rtl">
                <div className="close-icon pointer" onClick={(e:any)=>closePopup()}></div>
                <div className="popup-content">
                    <div className="popup-header">
                        <div className="popup-title">
                            {props.messageTitle}
                        </div>
                    </div>
                    <div className="popup-body">
                        <div className="clients-tabs-client-card-tabs client-details-view">
                            <div className={`client-card-tab pointer ${tab == 'Statuses' ? 'selected' : ''}`} onClick={()=>selectTab('Statuses')}>
                                <div className="label">
                                    סטטוסים
                                </div>
                                <div className="under-line"></div>
                            </div>
                        </div>
                        <div className={`client-tab-content client-details-edit-mode ${tab == 'Statuses' ? '' : 'hide'}`}>
                            <div style={{flexGrow: 1, maxWidth: '400px'}}>
                                <div className="parameter-row">
                                    <div className={`parameter-item`}>
                                        <div className="field">
                                            <div className="title">
                                            שם סטטוס:
                                            </div>
                                            <div className="value">
                                                <input type='text' value={newStatusName} onChange={onNewStatusNameChange} />
                                            </div>
                                            <div className='error-message'>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{paddingTop: '42px'}}>
                                        <button className='button blue flex-centered flex-justify-center' onClick={onAddStatus}>הוסף</button>
                                    </div>  
                                </div>
                                <div className='content-table'>
                                {statuses && statuses.map((aStatus: any, index) =>{
                                    return (
                                    <div className='item-data-row' key={index}>
                                        <div className='cell'>{aStatus.name}</div>
                                        <div className='cell item-actions pointer'>
                                            {
                                                !aStatus.isLock && 
                                                <FontAwesomeIcon className='pointer' icon={faTrash} onClick={()=>onDeleteStatus(aStatus.id)} />
                                            }
                                        </div>
                                    </div>
                                    )
                                })}
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="popup-footer">
                        <button className="button white blue-border pointer"  onClick={(e:any)=>closePopup()}>
                            סגור
                        </button>
                    </div>
                </div>
            </section>
        </div>
      </>  
        
      );
    // }
  }
export default SigningConfigPopup;